import api from "@/services/api";
import { ENDPOINTS } from "@/constants/endpoints";
import url from "@/helpers/url";

export default {
  async index(props) {
    try {
      const { data } = await api.get(url(ENDPOINTS.apiv4Representation, {}), {
        params: api.params(props),
      });
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async representation(props) {
    try {
      const { data } = await api.get(
        url(ENDPOINTS.apiv4UserRepresentationInverse, props)
      );
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async addRepresentation(props) {
    return await api.post(ENDPOINTS.apiv4Representation, props);
  },
  async changeRepresentation(user_id, role_id) {
    return await api.patch(ENDPOINTS.change_representation, {
      user_id: user_id,
      role_id: role_id,
    });
  },
  async delete(id) {
    try {
      const { data } = await api.delete(
        url(ENDPOINTS.apiv4RepresentationDelete, { id: id })
      );
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
};
